import { PRODUCT_DISPLAY_LIMIT } from 'pages/Products/ProductConstants';
import { ProductState } from 'types/productTypes';

export const ProductFormInitialState: ProductState = {
  countSubmit: 0,
  showAllValidateErrors: false,
  isEdit: false,
  editStoreId: null,
  editProductId: null,
  isDeleteImg: 0,
  error: '',
  success: '',
  modalBackdrop: false,
  loading: false,
  errorMsg: false,
  selectedFiles: [],
  alertMessage: null,
  isNoStock: false,
  isNoFragment: true,
  isPieces: true,
  displayVatPercentage: '',
  searchCategory: {
    productsCategoryOptions: [{ options: [] }],
    isCatOptionsLoading: false,
  },
  searchSuppliers: {
    supplierOptions: [{ options: [] }],
    isSupplierOptionsLoading: false,
  },
  imgDisplay: '',
  imgNameFromAPI: '',
  pageConfig: {
    custom_item_code: true,
    default_tax_1_rate: 0,
    group_price: [],
  },
  productFormDetails: {
    productName: '',
    productCode: '',
    pageConfig: {
      custom_item_code: true,
      default_tax_1_rate: 0,
      group_price: [],
    },
    barcode: '',
    category: '',
    supplier: '',
    productDetails: '',
    cost_price: {
      value: '0',
      apply_all: 0,
    },
    unit_price: {
      value: '0',
      apply_all: 0,
    },
    unit_price1: {
      value: '0',
      apply_all: 0,
    },
    unit_price2: {
      value: '0',
      apply_all: 0,
    },
    unit_price3: {
      value: '0',
      apply_all: 0,
    },
    unit_price4: {
      value: '0',
      apply_all: 0,
    },
    vat: '0',
    product_stock_type: '0',
    unit_type: '0',
    inventory_type: '1',
    first_page_pos: false,
    display_pos: false,
    composites: [],
    // addOns: [],
    // productOptions: [
    //   {
    //     name: 'color',
    //     selected: true,
    //     options: [{ name: 'blue', value: '10' }],
    //   },
    //   {
    //     name: 'size',
    //     selected: false,
    //     options: [
    //       { name: 'S', value: '10' },
    //       { name: 'M', value: '20' },
    //       { name: 'L', value: '30' },
    //     ],
    //   },
    // ],
    productOptions: [],
    pricesByBranch: [],
    quantity_notify: '0',
    tags: [],
  },
  productEditFormDetails: {},
  compositeModal: {
    activeInputIndex: null,
    isModalOpen: false,
    searchResults: [],
    searchTerm: '',
  },
  PageFilters: {
    productName: '',
    branch: [],
    category: '',
    quantityMin: '',
    quantityMax: '',
    barcode: '',
    code: '',
    supplier: '',
    tag_ids: [],
  },
  PageDetails: {
    entriesPerPage: PRODUCT_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },
  searchListCache: {
    cacheKey: null,
    latestSearchItemIds: null,
    productList: [],
    productTotal: 0,
  },
  PriceModal: {
    activePriceIndex: null,
    EditKey: null,
    priceModalOpen: false,
    PriceValues: {
      store_id: '',
      item_id: '',
      item_id_number: '',
      cost_price: '',
      unit_price: '',
      unit_price1: '',
      unit_price2: '',
      unit_price3: '',
      unit_price4: '',
    },
    countSubmit: 0,
    showAllValidateErrors: false,
    FormErrorCount: 0,
  },
  PriceBranchOptions: [],
  PriceBranch: [],
  selectMultiTags: [],
  selectMultiTagsFilter: [],
};
